import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { Component } from '../component';
import { changeSubscribe, CHANGE_TOPIC } from '../Datum/types';
import { isFunc } from '../utils/is';

var Flow =
/*#__PURE__*/
function (_Component) {
  _inherits(Flow, _Component);

  var _super = _createSuper2(Flow);

  function Flow(props) {
    var _this;

    _classCallCheck(this, Flow);

    _this = _super.call(this, props);
    _this.update = void 0;
    _this.events = void 0;
    _this.update = _this.forceUpdate.bind(_assertThisInitialized(_this));
    _this.events = [];
    var _this$props = _this.props,
        names = _this$props.names,
        formDatum = _this$props.formDatum;

    if (names) {
      names.forEach(function (n) {
        var nc = changeSubscribe(n);
        formDatum.subscribe(nc, _this.update);

        _this.events.push(nc);
      });
    } else {
      formDatum.subscribe(CHANGE_TOPIC, _this.update);

      _this.events.push(CHANGE_TOPIC);
    }

    return _this;
  }

  _createClass(Flow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Flow.prototype), "componentWillUnmount", this).call(this);

      var formDatum = this.props.formDatum;
      this.events.forEach(function (n) {
        return formDatum.unsubscribe(n);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          formDatum = _this$props2.formDatum;
      if (isFunc(children)) return children(formDatum) || null;
      return children;
    }
  }]);

  return Flow;
}(Component);

export default Flow;